// Cognito configuration interface
export interface CognitoConfig {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
  identityPoolId?: string;
  domain?: string;
}

// Default configuration (can be overridden by environment variables)
const defaultConfig: CognitoConfig = {
  region: import.meta.env.VITE_AWS_REGION || 'eu-west-1',
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  userPoolWebClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID || '',
  domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
};

// Export configuration
export const cognitoConfig: CognitoConfig = defaultConfig;

// Validate configuration
export const validateCognitoConfig = (config: CognitoConfig = cognitoConfig): boolean => {
  const requiredFields = ['region', 'userPoolId', 'userPoolWebClientId'];
  const missingFields = requiredFields.filter((field) => !config[field as keyof CognitoConfig]);

  if (missingFields.length > 0) {
    console.error('Missing required Cognito configuration fields:', missingFields);
    return false;
  }

  return true;
};
